import { memo as Memo, useCallback, useRef, useEffect } from 'react';
import { TweenLite } from 'gsap';

//* HOC's
import withUIContext from '@context/consumerHOC/UIConsumer';

//* Helpers
import stringToLetters from '@helpers/stringToLetters';

//* Styles
import OurSocialContactsStyle from './style';

//* Components
import CustomLink from '../CustomLink';
import Text from '../Text';

const OurSocialContacts = Memo(({ router, minType, globalData, ...props }) => {
	//! Refs
	const ref = useRef([]);

	//! Letter Spacing Animation
	useEffect(() => {
		for (let i = 0; i < ref.current.length; i++) {
			TweenLite.set(ref.current[i].children[0].childNodes, { letterSpacing: 0 });
		}
	}, []);

	const handleHover = useCallback((bool, ind) => {
		let arr = ref.current[ind].children[0].childNodes;

		if (bool) {
			for (let i = 0; i < arr.length; i++) {
				TweenLite.to(arr[i], 0.3, { letterSpacing: (arr.length - i) / 1.2 }, 0);
			}
		} else {
			for (let i = 0; i < arr.length; i++) {
				TweenLite.to(arr[i], 0.3, { letterSpacing: 0 }, 0);
			}
		}
	}, []);

	return globalData?.socials.length > 0
		? globalData.socials.map((item, ind) => {
				return (
					<OurSocialContactsStyle key={ind}>
						<CustomLink
							external
							url={item.url}
							ref={(el) => (ref.current[ind] = el)}
							onMouseEnter={() => handleHover(true, ind)}
							onMouseLeave={() => handleHover(false, ind)}
							className={`${minType ? 'h5' : 'p-l'} font-poppins font-regular font-italic crCircle followUsItem`}>
							{stringToLetters(item.name)}
						</CustomLink>

						<Text
							tag={'span'}
							className={`${minType ? 'h5' : 'p-l'} font-poppins font-light`}>
							{ind !== globalData.socials.length - 1 ? ', ' : ''}
						</Text>

						{minType ? (ind + 1) % 3 === 0 && ind !== 0 && props.winWidth >= props.screenSizes.screenXS ? <br /> : null : ind % 3 === 0 && props.winWidth >= props.screenSizes.screenXS ? <br /> : null}
					</OurSocialContactsStyle>
				);
		  })
		: null;
});

export default withUIContext(OurSocialContacts, ['winWidth', 'screenSizes', 'globalData']);
